// Copies of endless-book's FICTION_GENRES / NONFICTION_CATEGORIES (client/src/pages/NewBook.jsx) and LANGUAGES
// (client/src/components/LanguagePicker.jsx) — the language names endless-book knows.
export const FICTION_GENRES = [
	'Fiction', 'Romance', 'Mystery', 'Thriller', 'Science Fiction', 'Fantasy',
	'Adventure', 'Historical', 'Horror', 'Comedy', 'Drama', 'Children\'s',
];

export const NONFICTION_CATEGORIES = [
	'History', 'Science & Nature', 'Biography & Memoir', 'Travel & Places',
	'Philosophy & Ideas', 'Health & Lifestyle', 'Business & Society',
];

export const BOOK_LANGUAGES = [
	'Afrikaans', 'Amharic', 'Arabic',
	'Basque', 'Bengali', 'Bulgarian',
	'Cantonese', 'Catalan', 'Croatian', 'Czech',
	'Danish', 'Dutch',
	'English', 'Estonian',
	'Filipino', 'Finnish', 'French',
	'Galician', 'German', 'Greek', 'Gujarati',
	'Hebrew', 'Hindi', 'Hungarian',
	'Icelandic', 'Indonesian', 'Irish', 'Italian',
	'Japanese',
	'Kannada', 'Korean',
	'Latvian', 'Lithuanian',
	'Malay', 'Malayalam', 'Mandarin Chinese', 'Marathi',
	'Norwegian',
	'Polish', 'Portuguese (Brazil)', 'Portuguese (Portugal)', 'Punjabi',
	'Romanian', 'Russian',
	'Serbian', 'Slovak', 'Slovenian', 'Spanish', 'Swahili', 'Swedish',
	'Tamil', 'Telugu', 'Thai', 'Turkish',
	'Ukrainian', 'Urdu',
	'Vietnamese',
	'Welsh',
];
